import type { ISerialize } from '@/objects/ISerialize';

export class SignalrEventProductionDeviceSubscribeParameters implements ISerialize {
    public EventID: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { EventID?: number }) {
        this.EventID = values.EventID ?? 0;
    }

    public serialize(): string {
        return '{' + `"EventID": ${JSON.stringify(this.EventID)}` + '}';
    }

    /**
     * Creates an instance of SignalrEventProductionDeviceSubscribeParameters from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { EventID?: number }): SignalrEventProductionDeviceSubscribeParameters {
        return new SignalrEventProductionDeviceSubscribeParameters(values);
    }

    public static _FromServerJson(json: any): SignalrEventProductionDeviceSubscribeParameters {
        return new SignalrEventProductionDeviceSubscribeParameters({ EventID: json.EventID });
    }

    /**
     * Creates an instance of SignalrEventProductionDeviceSubscribeParameters from another instance of SignalrEventProductionDeviceSubscribeParameters.
     * @param other The SignalrEventProductionDeviceSubscribeParameters you want to clone
     * @returns A cloned SignalrEventProductionDeviceSubscribeParameters
     */
    public static FromOther(other: SignalrEventProductionDeviceSubscribeParameters): SignalrEventProductionDeviceSubscribeParameters {
        return SignalrEventProductionDeviceSubscribeParameters._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SignalrEventProductionDeviceSubscribeParameters.FromOther(this);
    }

    static NAME_OF_CLASS = 'SignalrEventProductionDeviceSubscribeParameters';
}
